/**
 * @fileoverview Hook for accessing authentication session context.
 */

import { useContext } from 'react';
import AuthSessionContext from '../context/AuthSessionContext';

interface AuthSessionContextValue {
  session: import('../context/AuthSessionContext').AuthSession | null;
  setSession: import('react').Dispatch<import('react').SetStateAction<import('../context/AuthSessionContext').AuthSession | null>>;
  loading: boolean;
}

export function useAuthSession(): AuthSessionContextValue {
  return useContext(AuthSessionContext);
}